import { Divider } from "@totalenergiescode/mobility-business-rev-design-system";
import { useTranslation } from "react-i18next";

import { NOTIFICATIONS_PER_PAGE } from "@/api/graphql/notifications/constants.ts";
import {
  StyledCard,
  StyledCardContainer,
  StyledCardTitle,
  StyledCurrentCountOnTotalContainer,
  StyledCurrentCountOnTotalText,
  StyledCustomTable,
  StyledCustomTableContainer,
  StyledEmailText,
  StyledPageHeader,
} from "@/components/Notifications/userList/styles.ts";
import { NotificationsUserListProps } from "@/components/Notifications/userList/types.ts";
import { EmptyDataForThisFilter } from "@/components/shared/EmptyComponent/component";
import { Loading } from "@/components/shared/Loading/component";

export const NotificationsListPerUser = ({
  id: userId,
  useNotificationTableData,
  useBreadCrumbItems,
}: NotificationsUserListProps) => {
  const { t: tCommon } = useTranslation("common");
  const { t: tNotifications } = useTranslation("notifications");
  const {
    columns,
    rows,
    totalNotifications,
    isUserLoading,
    isNotificationsLoading,
    user,
    hasNextPage,
    fetchNextPage,
  } = useNotificationTableData(userId);
  const breadcrumbItems = useBreadCrumbItems(
    `${user?.firstName} ${user?.lastName}`,
  );

  return (
    <>
      <StyledPageHeader
        breadcrumbItems={breadcrumbItems}
        title={tNotifications("notifications.title")}
        href={""}
      />
      <Loading isLoading={isUserLoading || false}>
        <StyledCardContainer>
          <StyledCard>
            <StyledCardTitle variant='title2'>
              {tNotifications("notifications.list.sentTo")}
            </StyledCardTitle>
            <Divider />
            <StyledEmailText variant={"text2"}>
              {user?.email || ""}
            </StyledEmailText>
          </StyledCard>
        </StyledCardContainer>
      </Loading>
      <Loading isLoading={isNotificationsLoading || false}>
        <StyledCustomTableContainer>
          <StyledCustomTable
            rows={rows}
            columns={columns}
            loadMoreButton={{
              dataTestId: "notifications__list_load-more-button",
              label: tCommon("common.pagination.nextPage", {
                pageSize: NOTIFICATIONS_PER_PAGE,
              }),
              onClick: fetchNextPage,
              isDisabled: !hasNextPage,
            }}
          />
          {totalNotifications === 0 && (
            <EmptyDataForThisFilter
              principalText={tNotifications("notifications.table.noData")}
            />
          )}
          <StyledCurrentCountOnTotalContainer>
            <StyledCurrentCountOnTotalText variant='sub3'>
              {tNotifications(
                "notifications.namesWithCurrentCountOnTotal.name",
                {
                  count: rows.length,
                  total: totalNotifications,
                },
              )}
            </StyledCurrentCountOnTotalText>
          </StyledCurrentCountOnTotalContainer>
        </StyledCustomTableContainer>
      </Loading>
    </>
  );
};
